import axios from "axios";
import React, { useState } from "react";
import {
  Button, Col, Form, FormControl, FormGroup, Row, Modal
} from "react-bootstrap";
import { base_url, postHeader } from "../../Helper/request";
import {toast } from "react-toastify";
import { useSelector } from "react-redux";
import ReCAPTCHA from "react-google-recaptcha";
import { crossIcon } from "../../Assets/svg";

const ContactForm = () => {
  const [otp, setotp] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [captchaStatus, setcaptchaStatus] = useState(true);
  const capthcaHandle = (res) => {
    if (res) {
      setcaptchaStatus(false);
    }
  };
  const storeLocation = useSelector(
    (state) => state.persistedReducer.home.store_locations
  );
  const clearAll = () => {
    setcontactData({
      ...contactData,
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      location: "",
      comment: "",
    });
  };
  const [loader, setloader] = useState(false);
  const [disableButton, setDisableButton] = useState(false);

  const [contactData, setcontactData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    location: "",
    comment: "",
  });
  const [validations, setValidations] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    location: "",
    comment: "",
  });
  const inputHandler = (e) => {
    setcontactData({
      ...contactData,
      [e.target.name]: e.target.value,
    });
  };
  const validateAll = () => {
    const validations = {
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      location: "",
      comment: "",
    };

    let isValid = true;

    if (!contactData.phone) {
      validations.phone = "Phone is required";
      isValid = false;
    }
    if (contactData.phone && contactData?.phone.length < 10) {
      validations.phone = "Phone must contain min 10 digits of number";
      isValid = false;
    }

    if (!contactData.email) {
      validations.email = "Email is required";
      isValid = false;
    }
    if (!contactData.first_name) {
      validations.first_name = "First name is required";
      isValid = false;
    }
    if (!contactData.last_name) {
      validations.last_name = "Last name is required";
      isValid = false;
    }
    if (contactData.location === "") {
      validations.location = "Location is required";
      isValid = false;
    }

    if (contactData.email && !/\S+@\S+\.\S+/.test(contactData.email)) {
      validations.email = "Email format must be as example@mail.com";
      isValid = false;
    }

    if (!isValid) {
      setValidations(validations);
    }

    return isValid;
  };
  const validateOne = (e) => {
    const { name } = e.target;
    const value = contactData[name];
    let message = "";

    if (!value) {
      message = `${name} is required`;
    }

    if (value && name === "email" && !/\S+@\S+\.\S+/.test(value)) {
      message = "Email format must be as example@mail.com";
    }
    if (value && name === "phone" && /^\d{9}$/.test(value)) {
      message = "Phone number must be in 10 digits";
    }

    setValidations({ ...validations, [name]: message });
  };
  const options = {
    method: "POST",
    headers: postHeader
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const isValid = validateAll();
    if (!isValid) {
      return false;
    }
    setDisableButton(true)
    setloader(true);


    const verifyPayload1 = {
      email: contactData?.email,
      first_name: contactData?.first_name,
      type: 1
    }
    axios.post(base_url + "/common/send_otp", verifyPayload1, options).then((res) => {
      if (res?.data?.status === 1) {
        const toastId = "success_data3";
        toast.success(
          <div className="position-relative">
            <div
              dangerouslySetInnerHTML={{
                __html: res?.data?.message || "successful!",
              }}
            />
            <button
              onClick={() => toast.dismiss(toastId)}
              className="noBtn closeManualToast"
            >
              {crossIcon}
            </button>
          </div>,
          {
            toastId,
            autoClose: false,
            closeOnClick: false,
            closeButton: false,
          }
        );
        handleShow()
        setloader(false);
      } else {
     const toastId = "login-error3";
        toast.error(
          <div className="position-relative">
            <div
              dangerouslySetInnerHTML={{
                __html: res?.data?.message || "An error occurred.",
              }}
            />
            <button
              onClick={() => toast.dismiss(toastId)}
              className="noBtn closeManualToast"
            >
              {crossIcon}
            </button>
          </div>,
          {
            toastId,
            autoClose: false,
            closeOnClick: false,
            closeButton: false,
          }
        );
        setloader(false);
      }
    });
  };

  const finalFormSubmit = () => {
    const isValid = validateAll()
    if (!isValid) {
      return false
    }
    setloader(true);
    setDisableButton(true)
    const successToastId = 'success-toast-id';
    axios.post(base_url + "/common/contact", contactData, options).then((res) => {
      if (res?.data?.status === 1) {
     const toastId = "success_data2";
        toast.success(
          <div className="position-relative">
            <div
              dangerouslySetInnerHTML={{
                __html: res?.data?.message || "successful!",
              }}
            />
            <button
              onClick={() => toast.dismiss(toastId)}
              className="noBtn closeManualToast"
            >
              {crossIcon}
            </button>
          </div>,
          {
            toastId,
            autoClose: false,
            closeOnClick: false,
            closeButton: false,
          }
        );
        clearAll();
        setloader(false);
        setDisableButton(false)
      } else {
         const toastId = "login-error2";
        toast.error(
          <div className="position-relative">
            <div
              dangerouslySetInnerHTML={{
                __html: res?.data?.message || "An error occurred.",
              }}
            />
            <button
              onClick={() => toast.dismiss(toastId)}
              className="noBtn closeManualToast"
            >
              {crossIcon}
            </button>
          </div>,
          {
            toastId,
            autoClose: false,
            closeOnClick: false,
            closeButton: false,
          }
        );
        setloader(false);
        setDisableButton(false)
      }
    });


  };

  const onSubmitOtp = (e) => {
    setloader(true);
    e.preventDefault()
    const verify2 = {
      email: contactData?.email,
      otp,
      type: 1
    }
    axios.post(base_url + "/common/verify_otp", verify2, options).then((res) => {
      if (res?.data?.status === 1) {
      const toastId = "success_data1";
        toast.success(
          <div className="position-relative">
            <div
              dangerouslySetInnerHTML={{
                __html: res?.data?.message || "successful!",
              }}
            />
            <button
              onClick={() => toast.dismiss(toastId)}
              className="noBtn closeManualToast"
            >
              {crossIcon}
            </button>
          </div>,
          {
            toastId,
            autoClose: false,
            closeOnClick: false,
            closeButton: false,
          }
        );
        handleClose()
        finalFormSubmit()
        // clearAll();
        // setloader(false);
      } else {
      const toastId = "login-error1";
        toast.error(
          <div className="position-relative">
            <div
              dangerouslySetInnerHTML={{
                __html: res?.data?.message || "An error occurred.",
              }}
            />
            <button
              onClick={() => toast.dismiss(toastId)}
              className="noBtn closeManualToast"
            >
              {crossIcon}
            </button>
          </div>,
          {
            toastId,
            autoClose: false,
            closeOnClick: false,
            closeButton: false,
          }
        );
        setloader(false);
      }
    });
  }

  return (
    <>
     
      <Form onSubmit={onSubmit}>
        <Row>
          <Col md={6} className="left-div">
            <Form.Group
              className="contact-input f-name"
              controlId="formBasicFname"
            >
              <div className="contact-input-inner">
                <Form.Label>
                  First Name <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  value={contactData?.first_name}
                  onChange={(e) => inputHandler(e)}
                  onBlur={validateOne}
                  name="first_name"
                  type="text"
                  placeholder="First Name"
                />
              </div>
              {validations?.first_name && (
                <div className="validation mt-1">
                  {validations?.first_name.replace("_", " ")}
                </div>
              )}
            </Form.Group>
            <Form.Group
              className="contact-input l-name"
              controlId="formBasicLname"
            >
              <div className="contact-input-inner">
                <Form.Label>
                  Last Name <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  value={contactData?.last_name}
                  onChange={(e) => inputHandler(e)}
                  onBlur={validateOne}
                  name="last_name"
                  type="text"
                  placeholder="Last Name"
                />
              </div>
              {validations?.last_name && (
                <div className="validation mt-1">
                  {validations?.last_name.replace("_", " ")}
                </div>
              )}
            </Form.Group>
            <Form.Group
              className="contact-input emailadd"
              controlId="formBasicEmail"
            >
              <div className="contact-input-inner">
                <Form.Label>
                  Email <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  value={contactData?.email}
                  onChange={(e) => inputHandler(e)}
                  onBlur={validateOne}
                  name="email"
                  type="email"
                  placeholder="Enter email"
                />
              </div>
              {validations?.email && (
                <div className="validation mt-1">
                  {validations?.email.replace("_", " ")}
                </div>
              )}
            </Form.Group>
            <Form.Group
              className="contact-input phoneno"
              controlId="formBasicPhone"
            >
              <div className="contact-input-inner">
                <Form.Label>
                  Phone Number <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  value={contactData?.phone}
                  onChange={(e) => inputHandler(e)}
                  onBlur={validateOne}
                  name="phone"
                  type="number"
                  placeholder="Phone Number"
                />
              </div>
              {validations?.phone && (
                <div className="validation mt-1">
                  {validations?.phone.replace("_", " ")}
                </div>
              )}
            </Form.Group>
            <FormGroup
              className="contact-input location"
              controlId="formControlsSelect"
            >
              <div className="contact-input-inner">
                <Form.Label>
                  Choose a Location <span className="text-danger">*</span>
                </Form.Label>
                <Form.Select
                  aria-label="Location"
                  onChange={(e) => inputHandler(e)}
                  onBlur={validateOne}
                  name="location"
                >
                  <option value="">Choose a Location</option>
                  {storeLocation?.map((stores) => (
                    <option value={stores.location}>{stores.location}</option>
                  ))}
                </Form.Select>
              </div>
              {validations?.location && (
                <div className="validation mt-1">
                  {validations?.location.replace("_", " ")}
                </div>
              )}
            </FormGroup>
          </Col>
          <Col md={6} className="right-div">
            <FormGroup controlId="formControlsTextarea">
              <div className="contact-input-inner">
                <Form.Label className="desktop_hide">Comment </Form.Label>
                <FormControl aria-label="Comment"
                  value={contactData?.comment}
                  onChange={(e) => inputHandler(e)}
                  onBlur={validateOne}
                  name="comment"
                  as="textarea"
                  componentClass="textarea"
                  placeholder="Comment"
                />
              </div>
            </FormGroup>

            <div className="mt-3">
              <ReCAPTCHA
                sitekey="6Lc6LUscAAAAAKO2DYPGrIPSnwx3fzROCxJzNWQ0"
                onChange={capthcaHandle}
              />
            </div>

            <Button
              variant="primary1"
              className="theme_btn"
              type="submit"
              disabled={captchaStatus ? true : disableButton ? true : false}
            >
              {loader ? "Sending..." : "Submit"}
            </Button>
          </Col>
        </Row>
      </Form>

      <Modal show={show} onHide={handleClose} centered
        backdrop="static"
        keyboard={false} >
        <Modal.Header closeButton>
          <Modal.Title> <h3 style={{ color: "#395754" }}>OTP</h3> </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={onSubmitOtp}>
            <div className='mb-3'>
              <p className='greenText'>We have sent OTP on your email:</p>
              <p className='greenText'>{contactData?.email}</p>
            </div>
            <div className='form-group'>
              <input placeholder='Enter OTP' className='form-control' type="text" name="otp" value={otp} onChange={(e) => setotp(e.target.value)} required />
            </div>
            <div className='form-group'>
              <button className='btnTheme' type='submit'>{loader ? "Sending..." : "Submit"}</button>
            </div>


          </Form>
        </Modal.Body>

      </Modal>
    </>
  );
};

export default ContactForm;
